import collab from '@/redux/requests/collab.js';

export const archiveThread = async ({ threadId } = {}) => {
  const normalizedThreadId = String(threadId || '').trim();
  const result = await collab.put('thread', {
    resourceId: normalizedThreadId,
    mutation: 'archive',
    action: 'ARCHIVE_THREAD',
    meta: { threadId: normalizedThreadId }
  });

  return result;
};

export const restoreThread = ({ threadId } = {}) => {
  const normalizedThreadId = String(threadId || '').trim();
  return collab.put('thread', {
    resourceId: normalizedThreadId,
    mutation: 'restore',
    action: 'RESTORE_THREAD',
    meta: { resourceId: normalizedThreadId }
  });
};
